import { render, staticRenderFns } from "./RightsStatementButton.vue?vue&type=template&id=4daef65b&scoped=true&"
import script from "./RightsStatementButton.vue?vue&type=script&lang=js&"
export * from "./RightsStatementButton.vue?vue&type=script&lang=js&"
import style0 from "./RightsStatementButton.vue?vue&type=style&index=0&id=4daef65b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daef65b",
  null
  
)

export default component.exports